import { ReactNode } from 'react'
import { styled } from 'styled-components'

import { Grid } from '../layout'
import { H1 } from '../typography/heading'

type FooterColumnType = {
	children: ReactNode
	title?: string
}

const StyledGrid = styled(Grid)`
	ul {
		list-style-type: none;
		line-height: ${({ theme }) => theme.lineHeights.base};
		font-size: ${({ theme }) => theme.fontSizes.base};
		padding: 0;
		a,
		button {
			font-weight: normal !important;
		}
	}
`

export const FooterColumn = ({ children, title }: FooterColumnType) => {
	return (
		<StyledGrid item xs={12} lg={4}>
			{title && <H1>{title}</H1>}
			{children}
		</StyledGrid>
	)
}
